import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaStore,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const OnlineMarketplaceWebsiteDevelopmentInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Online Marketplace Website Development in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Build Your Market</Subheading>}
        heading={
          <Heading>
            Online <span tw="text-primary-500">Marketplace Development</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in online marketplace website
            development in **DIFC**, creating robust, scalable platforms that
            connect vendors and buyers seamlessly, driving commerce in Dubai’s
            financial hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1612469293568-38a5cdbdb5cc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Marketplace"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Marketplace Solutions in DIFC"
        description="We build marketplaces that empower businesses and customers."
        cards={[
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Multi-Vendor Support",
            description: "Seamless integration for multiple sellers.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Transaction Ease",
            description: "Smooth, secure buying experiences.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Expert Development",
            description: "Built by DIFC’s top marketplace pros.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Platforms",
            description: "Grow without limits, fast and reliable.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Flawless access on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred for marketplace innovation.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Marketplace Development Process"
        description={
          <Description>
            We create online marketplaces with a strategic approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define your marketplace vision and goals.</li>
              <li>Design: Craft intuitive, vendor-friendly interfaces.</li>
              <li>Development: Build secure, multi-vendor platforms.</li>
              <li>Testing: Ensure performance and usability across users.</li>
              <li>Launch: Deliver a polished, ready-to-scale marketplace.</li>
              <li>Support: Provide ongoing optimization and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1526406915894-7bcd65f60845?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Marketplace Success in DIFC"
        description="Our platforms transform commerce."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "Increased vendor sales by 200%.",
          },
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Vendor Expansion",
            description: "Onboarded 50+ sellers seamlessly.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "98% satisfaction from DIFC clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Connect?</Subheading>}
        heading="Marketplace Innovation in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for online marketplace website
            development in DIFC. Create a thriving, scalable platform that
            empowers vendors and buyers—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1532363814356-df99100ae399?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1475873326779-3eae1a9c0d13?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
